module.exports = __webpack_public_path__ + "static/media/invalid.73368891.svg";